<div
  class="flex flex-col items-center justify-center text-center p-6 max-w-md w-full"
>
  <!-- Button -->
  <button
    class="btn btn-md btn-primary w-full mb-4 flex justify-center items-center"
    (click)="navigateToJiraOAuth()"
  >
    <span *ngIf="!isLoading">Connect to Jira</span>
    <span *ngIf="isLoading">Connecting</span>
    <div class="loader ms-2" *ngIf="isLoading"></div>
  </button>

  <!-- Skip link -->
  <!-- <div class="text-sm">
    <span class="text-gray-500">Don’t want to connect right now?</span>
    <a class="text-default-primary cursor-pointer ml-1">Skip</a>
  </div> -->
</div>
